import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';


@Injectable()
export class AuthGuard implements CanActivate {



  constructor(private afAuth: AngularFireAuth, private router: Router, private authService: AuthService) {}



  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|boolean {
    return this.afAuth.authState.pipe(map(x => {
      if (x) {
        console.log('AuthGuard is allowing you to proceed')
        return true;
      } else {
        console.log('Access denied by AuthGuard, routing to login!');
        // If someone tries to access a page that requires them to be logged in...
        // Make them log in through the login page, and then redirect them to their original target
        // Store the attempted URL for post-login redirecting
        console.log('storing attempted url in authService.originalAttemptedUrl:');
        console.log(state.url);
        this.authService.originalAttemptedUrl = state.url;
        // Navigate to the login page
        this.router.navigate(['home/login']);
        return false;
      }
    }));
  }



}

// Doesnt like the .map
// Will not compile

// canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
//   return this.afAuth.authState.map(auth => {
//     // If there is no authentication info
//     if (!auth) {
//       console.log('Access denied by AuthGuard, routing to login!');
//       // If someone tries to access a page that requires them to be logged in...
//       // Make them log in through the login page, and then redirect them to their original target
//       // Store the attempted URL for post-login redirecting
//       console.log('storing attempted url in authService.originalAttemptedUrl:');
//       console.log(state.url);
//       this.authService.originalAttemptedUrl = state.url;
//       // Navigate to the login page
//       this.router.navigate(['home/login']);
//       return false;
//     } else {
//       // If there is authentication info, allow them to proceed
//       return true;
//     }
//   });
// }



// Gets an error saying 'error TS1128: Declaration or statement expected.'
// Kind of works, can compile anyways and serve.
// Pages load, auth-guard partically works, but error gets triggered on login "cannot set property 'uid' of null" in authService line 42
// After login, will be directed to Admin Dashboard, and trying to go there without login triggers auth-guard re-route, but....
// ... after login, navigating home then clicking Admin Dashboard will trigger auth-guard re-route

// canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
//   return new Promise( (resolve, reject) => {
//     this.afAuth.authState.subscribe(
//       auth => {
//         // If there is no authentication info
//         if (!auth) {
//           console.log('Access denied by AuthGuard, routing to login!');
//           // If someone tries to access a page that requires them to be logged in...
//           // Make them log in through the login page, and then redirect them to their original target
//           // Store the attempted URL for post-login redirecting
//           console.log('storing attempted url in authService.originalAttemptedUrl:');
//           console.log(state.url);
//           this.authService.originalAttemptedUrl = state.url;
//           // Navigate to the login page
//           this.router.navigate(['home/login']);
//           // return false;
//           resolve(false)
//         } else {
//           // If there is authentication info, allow them to proceed
//           // return true;
//           resolve(true)
//         }
//       },
//       err => { console.log(err); resolve(true); },
//       () => { console.log('completed'); resolve(true); }
//     )
//   )     <-----------       <-----------        <-----------         <-----------      <-----------       This is where the red underline is
// }











